import { render } from "./CancelTicket.vue?vue&type=template&id=0f32a0d3&scoped=true"
import script from "./CancelTicket.vue?vue&type=script&lang=js"
export * from "./CancelTicket.vue?vue&type=script&lang=js"

import "./CancelTicket.vue?vue&type=style&index=0&id=0f32a0d3&scoped=true&lang=css"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f32a0d3"]])

export default __exports__